// src/types/blogTypes.ts

export const BLOG_AUTHOR = 'Chots Team';

export type BlogCategory =
  | 'Wellbeing'
  | 'Career'
  | 'Everyday Life'
  | 'Creativity'
  | 'Language'
  | 'Productivity'
  | 'Style & Culture'
  | 'Learning'
  | 'Behind Chot Buddies';

export type BlogProduct = 'chot-buddies' | 'chot-study';

/** Icon shown on the post card. Each name maps to a FontAwesome icon in components/blog/blogIcons.ts. */
export type BlogIconName =
  | 'users'
  | 'moon'
  | 'handshake'
  | 'user-tie'
  | 'scale'
  | 'utensils'
  | 'microphone'
  | 'landmark'
  | 'pen-nib'
  | 'city'
  | 'wand'
  | 'shield'
  | 'brain'
  | 'calendar'
  | 'language'
  | 'comments'
  | 'spell-check'
  | 'checklist'
  | 'stopwatch'
  | 'shirt'
  | 'ring'
  | 'newspaper'
  | 'hashtag';

export interface BlogPost {
  /** URL slug, lowercase and hyphenated. Also used as the file name. */
  slug: string;
  title: string;
  /** Meta description and card summary. 110-160 characters. */
  description: string;
  category: BlogCategory;
  /** Icon for the card thumbnail. */
  icon: BlogIconName;
  /** ISO date, YYYY-MM-DD. */
  publishedAt: string;
  author: typeof BLOG_AUTHOR;
  /** Which product the closing call-to-action points to. */
  product: BlogProduct;
  /** Buddy featured in the post, if any (for example "Sage"). */
  buddy?: string;
  /** Primary search keyword first. */
  keywords: string[];
  /** Lightweight markdown. See memory-bank/blogGuidelines.md for the supported syntax. */
  body: string;
}

export type BlogInline =
  | { type: 'text'; text: string }
  | { type: 'bold'; text: string }
  | { type: 'italic'; text: string }
  | { type: 'link'; text: string; href: string };

export type BlogBlock =
  | { type: 'h2'; text: string }
  | { type: 'h3'; text: string }
  | { type: 'p'; text: string }
  | { type: 'quote'; text: string }
  | { type: 'ul'; items: string[] }
  | { type: 'ol'; items: string[] };
